import React from 'react';
import { AdminLayout, SidebarLink } from '@britishcouncil/react-admin';

import { LOGOS, ROUTING_PATHS } from 'const';
import { useGetPermissionsQuery } from 'store';
import { Sidebar } from './Sidebar';

type LayoutProps = {
  children?: React.ReactNode;
};

export const Layout = ({ children }: LayoutProps) => {
  const { isFetching } = useGetPermissionsQuery();

  return (
    <AdminLayout
      appName="Examiner Management"
      theme="yellow"
      sidebarItems={<Sidebar />}
      isSidebarLoading={isFetching}
      appLogo={LOGOS.EmmLogoUrl}
      bottomSidebarItems={<SidebarLink icon="power off" name="Logout" to={ROUTING_PATHS.logout} />}
    >
      {children}
    </AdminLayout>
  );
};
